var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"crossorigin":"anonymous"}}),_c('button',{on:{"click":_vm.changePanoramic}},[_vm._v("Change Panoramic")])])
}
var staticRenderFns = []

export { render, staticRenderFns }